"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Pagination = _interopRequireDefault(require("../../../components/Pagination"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    selected: {},
    icon: {
      fill: theme.palette.primary.main
    }
  };
}, {
  name: 'CatalogueProductListPagination'
});

function CatalogueProductListPagination(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      count = _ref.count,
      onChangePage = _ref.onChangePage,
      page = _ref.page,
      rowsPerPage = _ref.rowsPerPage,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "count", "onChangePage", "page", "rowsPerPage"]);
  var classes = useStyles({
    classes: pClasses
  });

  var handleChange = _react.default.useCallback(function (e, v) {
    onChangePage(v - 1);
  }, [onChangePage]);

  return /*#__PURE__*/_react.default.createElement(_Pagination.default, (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className),
    count: Math.ceil(count / rowsPerPage),
    page: page,
    onChange: handleChange,
    variant: "outlined",
    shape: "rounded"
  }));
}

process.env.NODE_ENV !== "production" ? CatalogueProductListPagination.propTypes = {
  classes: _propTypes.default.shape({
    button: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  count: _propTypes.default.number,
  onChangePage: _propTypes.default.func,
  page: _propTypes.default.number,
  rowsPerPage: _propTypes.default.number
} : void 0;
CatalogueProductListPagination.defaultProps = {
  classes: undefined,
  className: undefined,
  count: undefined,
  onChangePage: undefined,
  page: undefined,
  rowsPerPage: undefined
};
var _default = CatalogueProductListPagination;
exports.default = _default;